import { render, staticRenderFns } from "./IsBankasiHGSChargeView.vue?vue&type=template&id=70a1b616&"
import script from "./IsBankasiHGSChargeView.vue?vue&type=script&lang=js&"
export * from "./IsBankasiHGSChargeView.vue?vue&type=script&lang=js&"
import style0 from "./IsBankasiHGSChargeView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports